// 치과 「접수」 데스크 화면 (/reception) — 2026-10-03 대표 지시 "지금 만든 접수 페이지는 그대로 치과 로그인 화면 맨 위 접수로 추가"
// 정본: 승인된 시뮬레이터 qr_waiting_sim.html 의 「치과 데스크 모니터」. 배치·문구는 시뮬레이터 기준, 스타일은 웹 관례(인라인).
//  - 큰 시계 / 대기 순서(접수 순 번호, [호출] 하나, 호출함은 아래로) / 환자 정보 칸
//    처음 온 환자 = 접수 카드 항목별 [복사] (getReceptionDetail — 접속기록 남는 경로) · 기존 환자 = 보철 이력
//    보철 이력: 의뢰서가 이 접수에 연결돼 있으면 「의뢰서 연결됨」(orderIds), 아니면 이름 검색 + 동명이인 안내
//  - 하단 「접수 기록」 월 캘린더(날짜별 인원·처음 온 환자 수) → 날짜 클릭 → 환자 목록 → 접수 정보·같은 이름 지난 기록·보철 이력, 이름 검색(전체 날짜·해당 날짜 강조)
//  - 이름은 가리지 않고 전부 표시. 상세 정보 칸은 30초 무조작 시 자동 닫힘(남은 초 표시) — 닫히면 접수 카드 내용도 메모리에서 비운다
//  - 시뮬레이터 전용이던 [하루 마감](실서비스=자정 자동, 서버)·「일어난 일」 기록 칸은 만들지 않는다
//  - 목록 갱신 = 5초 폴링(컬렉션은 클라이언트 차단 예정이라 onSnapshot 불가). 서버 미배포면 "접수 서버 준비 중" 표시
//  - 콘솔에 환자 이름·번호·주소 기록 금지(오류 코드만)
// 10-04: 첫 진입 시 치과 처리위탁 확인(DeskClinicConsentCard) — 미확인이면 데스크 위에 확인 카드 + "QR 접수가 아직 시작되지 않았습니다".
//   보호자(법정대리인) 접수: 대기 목록에는 아이 이름만, 보호자 이름·관계는 상세(getReceptionDetail — 접속기록)에서만(정본 §7-1)
// 10-04: [이 접수 삭제] — 상세 칸(오늘·기록 둘 다) 맨 아래, 치과 대표만. 사유 선택 → 화면 안 확인 → deleteReceptionEntry(id, reason).
//   대표 판정 = 서버 resolveClinicActor(clinic-patients.js:825-827, companyId 없거나 자기 uid = owner)와 같고, userType 'staff' 는 추가로 숨김(더 좁게).
//   직원이 우회해도 서버가 permission-denied owner-only 로 거부. 성공 시 상세 닫기 + 오늘 목록·캘린더 월·일 목록 다시 불러오기
// 10-04 데스크 직접 추가(기획서_접수_수동추가 — 대표 결정 5건 권고대로): 「대기 순서」 머리 [+ 직접 추가] → 목록 위 한 줄 입력부
//   (이름 필수 + 오신 이유 버튼 4개 선택) → addDeskWalkin → 그날 대기 맨 뒤. 목록 줄에 「데스크 추가」 배지·[빼기](대표·직원, 화면 안 확인 1단계).
//   데스크 추가 건은 상세(getReceptionDetail)·보철 이력(이름 검색)을 부르지 않는다 — 이름·이유만(처리위탁 1.2: 그날 대기 안내·의뢰서 이름 채우기에만).
//   처리위탁 확인: 1.1 확인 치과(confirmed·isCurrent:false)는 QR 접수가 그대로 되므로 데스크를 막지 않는다(맨 위 카드 showReconfirm=false).
//   1.2 확인은 직접 추가 영역에서만 묻는다(DeskClinicConsentCard variant 'deskAdd' — 대표 확인 / 직원 "대표가 확인해야 합니다"). 서버 deskAddFrom 이 미래면 "○월 ○일부터".
// 게이트: App.js /reception 라우트(치과 && isDeskReceptionOn) + MainLayout 메뉴. 데스크 QR 인쇄·재발급은 /settings/walkin-qr(ClinicWalkinQr) 재사용
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';   // 2026-10-06 [데스크 QR 보기] 비노출로 미사용 — 되살릴 때 주석 해제
import {
    listTodayReception, callReception, getReceptionDetail, listReceptionMonth, listReceptionDay, searchReceptionHistory,
    deleteReceptionEntry, addDeskWalkin, removeDeskWalkin,
} from '../../services/receptionApi';
import { fetchOrdersByPatientName, fetchOrdersByIds } from '../../services/receptionOrders';
import DeskClinicConsentCard from './DeskClinicConsentCard';
import DoctorCallCard from './doctorCall/DoctorCallCard';   // 🔔 원장 호출 3번째 카드 (2026-10-08, 플래그 doctorCall strict)
import { getFeatures, isDoctorCallOn, isCareAppReceptionOn } from '../../utils/features';
import { timed } from '../../utils/dcTiming';   // ⏱️ 누름→서버 응답 ms 측정(10-08 대표 증상 확인용)
// 2026-10-06 대표 지시: 접수 화면 상단 바의 「새 앱 등록 N명」 배지·[진료 끝]·[데스크 QR 보기] 비노출 — 기능은 각각 「오늘」(/clinic-today 카드)·환자 상세 [진료 끝 ▾]·설정 /settings/walkin-qr 에 유지. 되살릴 때 아래 주석 해제
// import ClinicSelfRegisterCard from './ClinicSelfRegisterCard';   // 「새 앱 등록 N명」 배지(덴클 케어 W3 — careApp OFF·0건이면 안 그림)
// import ClinicPatientPicker from './ClinicPatientPicker';   // 🗺️ [진료 끝] → 명부에서 환자 고르기(접수 행과 자동 결합 없음 — 계약_질문로드맵_웹 §2)
// import { CareTrackStartModal } from './CareTrackStart';   // 🗺️ 고른 환자의 [진료 끝 ▾]/[장착 완료] (환자 상세와 같은 흐름)
// import { useRoadmapPilot } from '../../utils/useRoadmapPilot';   // 🗺️ 진료 후 질문 노출 = 플래그 AND 파일럿 치과(서버 위탁 확인) (2026-10-06)
import {
    reasonLabel, sexLabel, kindLabel, guardianRelationLabel, RECEPTION_AUTO_CLOSE_SEC, RECEPTION_POLL_MS, receptionDeskError,
    RECEPTION_DELETE_REASONS, receptionDeleteError,
    RECEPTION_REASONS, isValidReceptionName, RECEPTION_NAME_HINT,
    isDeskEntry, isAppEntry, APP_RECEPTION_BADGE, receptionKindLabelOf, receptionDeskAddError, receptionDeskRemoveError, fmtMonthDay,
    kstParts, kstDayKey, fmtDayKey, fmtHM, WEEKDAYS,
} from '../../utils/deskReception';

const pad = (n) => String(n).padStart(2, '0');
const normName = (s) => String(s || '').normalize('NFC').trim();

// 보철 이력 로더 — 연결된 의뢰서 우선, 없으면 이름 완전 일치 검색
async function loadOrderHistory(clinicId, item) {
    const ids = Array.isArray(item?.orderIds) ? item.orderIds.filter(Boolean) : [];
    if (ids.length) {
        const r = await fetchOrdersByIds(ids);
        return { mode: 'linked', rows: r.rows, missing: r.missing };
    }
    const rows = await fetchOrdersByPatientName(clinicId, item?.name);
    return { mode: 'name', rows, missing: 0 };
}

function DeskReception({ user }) {
    // const navigate = useNavigate();   // 2026-10-06 [데스크 QR 보기] 비노출로 미사용(설정 /settings/walkin-qr 에서 사용)
    // 훅은 전부 최상단 — early return 위 (Dashboard 사고)
    const clinicId = user?.companyId || user?.uid;
    const clinicName = user?.companyName || user?.businessName || user?.name || '';
    // 삭제 버튼 노출 = 치과 대표만 (서버 owner 판정: companyId 없음 또는 companyId === uid)
    const isOwner = user?.userType !== 'staff' && (!user?.companyId || user.companyId === user?.uid);
    // 삭제 진행 상태 — null | { panel:'today'|'hist', id, reason, step:'pick'|'confirm', busy, err }
    const [del, setDel] = useState(null);
    const [listRev, setListRev] = useState(0);   // 삭제 후 캘린더 월·일 목록 다시 불러오기용
    // 🔔 원장 호출 카드(윗줄 3번째) — config/features.doctorCall strict. OFF·로딩 중이면 카드 자체를 그리지 않는다(구독 0)
    const [doctorCallOn, setDoctorCallOn] = useState(false);
    // 📱 케어 앱 접수(2026-10-11, careAppReception strict) — 하단 안내에 "앱 접수"를 넣을지만 정한다. 「앱 접수」 배지는 서버 source 'app' 데이터 기준(플래그 무관)
    const [appReceptionOn, setAppReceptionOn] = useState(false);
    useEffect(() => {
        let alive = true;
        getFeatures().then(f => { if (alive) { setDoctorCallOn(isDoctorCallOn(f)); setAppReceptionOn(isCareAppReceptionOn(f)); } })
            .catch(e => console.error('[접수] 원장 호출 플래그 조회 실패:', e?.message || e));
        return () => { alive = false; };
    }, []);

    const [now, setNow] = useState(() => new Date());
    // 처리위탁 확인(10-04) — DeskClinicConsentCard onState: { loading, confirmed, isCurrent, canConfirm, deskAddReady, deskAddFrom, deskAddVersion }
    const [clinicConsent, setClinicConsent] = useState({ loading: true, confirmed: false, deskAddReady: false, deskAddFrom: null });
    // 데스크 직접 추가 입력부 — 입력값은 메모리에만(저장소 금지). rm = [빼기] 확인 중인 줄 { id, busy, err }
    const [addOpen, setAddOpen] = useState(false);
    const [addName, setAddName] = useState('');
    const [addReason, setAddReason] = useState('');
    // 직접 추가 진행 표시는 목록의 임시 행(「넣는 중」)으로 대신한다(10-08 — 버튼 잠금·글자 바꿈 없음, 연속 추가 가능)
    const [addErr, setAddErr] = useState('');
    const [rm, setRm] = useState(null);
    const lastActRef = useRef(Date.now());
    // 🗺️ 진료 후 질문(플래그 roadmapEngine strict AND 파일럿 치과 — useRoadmapPilot, fail-closed) — OFF면 [진료 끝] 버튼 비노출
    // 2026-10-06 접수 화면 [진료 끝] 비노출(대표 지시) — 환자 상세 [진료 끝 ▾]로 일원화. 되살릴 때 주석 해제(훅은 early return 위 이 자리 유지)
    // const { on: roadmapOn } = useRoadmapPilot(user);
    // const [trackPick, setTrackPick] = useState(false);      // 명부 고르기 모달
    // const [trackTarget, setTrackTarget] = useState(null);   // 고른 환자 { id, name, aftercareOn }
    const [toast, setToast] = useState('');
    const toastTimer = useRef(null);
    const showToast = useCallback((m) => {
        setToast(m);
        if (toastTimer.current) clearTimeout(toastTimer.current);
        toastTimer.current = setTimeout(() => setToast(''), 2400);
    }, []);

    // ── 오늘 대기 목록 (5초 폴링)
    const [items, setItems] = useState([]);
    const [listErr, setListErr] = useState('');
    const [listLoaded, setListLoaded] = useState(false);
    const [freshIds, setFreshIds] = useState([]);
    const knownIdsRef = useRef(null);
    const listErrRef = useRef('');
    // 즉시 반영(10-08 대표 증상 "누를 때마다 느리다") — 서버 응답을 기다리지 않고 목록을 먼저 바꾼다.
    //  5초 폴링이 서버 반영 전 옛 목록을 돌려줘도 되돌아가지 않게, 대기 중 변경을 덮어 적용(서버 목록이 따라오면 자동 해제):
    //   called: id → calledAt(호출 누름) / removed: 뺀·삭제한 id / temps: 직접 추가 임시 행 { row, serverId }
    const optRef = useRef({ called: new Map(), removed: new Set(), temps: [] });
    const inflightRef = useRef(new Set());   // 같은 줄 [호출] 연타 가드(화면 변화 없이 무시)
    const applyOpt = useCallback((server) => {
        const o = optRef.current;
        const ids = new Set(server.map(x => x.id));
        o.removed.forEach(id => { if (!ids.has(id)) o.removed.delete(id); });
        let list = server.filter(x => !o.removed.has(x.id)).map(x => {
            if (!o.called.has(x.id)) return x;
            if (x.status === 'called') { o.called.delete(x.id); return x; }
            return { ...x, status: 'called', calledAt: o.called.get(x.id) };
        });
        o.temps = o.temps.filter(t => !(t.serverId && ids.has(t.serverId)));
        list = list.concat(o.temps.map(t => (t.serverId ? { ...t.row, id: t.serverId, _temp: false } : t.row)));
        return list;
    }, []);

    // logView=true: 첫 진입(·수동 새로고침)에서만 접속기록 요청. 폴링·동작 뒤 재조회는 인자 없이(기록 안 쌓임)
    const loadToday = useCallback(async (logView = false) => {
        try {
            const r = await listTodayReception(logView === true ? { log: true, client: 'web' } : undefined);
            const list = Array.isArray(r?.items) ? r.items : [];
            setItems(applyOpt(list));
            setListLoaded(true);
            // 새로 들어온 줄 잠깐 강조(시뮬레이터 .fresh)
            if (knownIdsRef.current) {
                const added = list.map(x => x.id).filter(id => !knownIdsRef.current.has(id));
                if (added.length) { setFreshIds(added); setTimeout(() => setFreshIds([]), 1500); }
            }
            knownIdsRef.current = new Set(list.map(x => x.id));
            if (listErrRef.current) { listErrRef.current = ''; setListErr(''); }
        } catch (e) {
            const msg = receptionDeskError(e, '대기 목록을 불러오지 못했습니다. 잠시 후 다시 시도합니다.');
            if (msg !== listErrRef.current) console.error('[접수] 대기 목록 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
            listErrRef.current = msg; setListErr(msg); setListLoaded(true);
        }
    }, [applyOpt]);

    useEffect(() => {
        loadToday(true);   // 첫 진입 — 열람 접속기록 1건
        const t = setInterval(() => { if (!document.hidden) loadToday(); }, RECEPTION_POLL_MS);
        return () => clearInterval(t);
    }, [loadToday]);

    // 시계 1초 — 자동 닫힘 남은 초도 같은 틱으로
    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 1000);
        return () => { clearInterval(t); if (toastTimer.current) clearTimeout(toastTimer.current); };
    }, []);

    const waitList = useMemo(() => items.filter(x => x.status !== 'called'), [items]);
    const calledList = useMemo(() => items.filter(x => x.status === 'called'), [items]);

    // ── 대기 순서 → 환자 정보 칸
    const [selId, setSelId] = useState(null);
    const [card, setCard] = useState({ loading: false, data: null, err: '' });          // 처음 온 환자 접수 카드
    const [hist, setHist] = useState({ loading: false, mode: '', rows: [], missing: 0, err: '' });   // 보철 이력
    const [copied, setCopied] = useState('');
    const sel = useMemo(() => items.find(x => x.id === selId) || null, [items, selId]);
    const selOrderKey = (sel?.orderIds || []).join(',');

    const pick = (id) => { setSelId(id); lastActRef.current = Date.now(); };

    useEffect(() => {
        if (!selId) { setCard({ loading: false, data: null, err: '' }); return undefined; }
        const it = items.find(x => x.id === selId);
        // 처음 온 환자, 또는 보호자 접수(기존 환자 포함 — 보호자 이름·관계는 상세에서만, 정본 §7-1 P2)
        if (!it || !needsDetail(it)) { setCard({ loading: false, data: null, err: '' }); return undefined; }
        let alive = true;
        setCard({ loading: true, data: null, err: '' });
        getReceptionDetail(selId).then(r => {
            if (alive) setCard({ loading: false, data: r?.card || null, err: r?.card ? '' : '접수 카드 내용이 없습니다.' });
        }).catch(e => {
            console.error('[접수] 접수 카드 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
            if (alive) setCard({ loading: false, data: null, err: receptionDeskError(e, '접수 카드를 불러오지 못했습니다.') });
        });
        return () => { alive = false; };
        // 선택이 바뀔 때만 조회(폴링마다 다시 부르지 않음 — 접속기록 중복 방지)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selId]);

    useEffect(() => {
        // 데스크 추가 건은 이름으로 의뢰서를 찾지 않는다(처리위탁 1.2: 이름 검색에 쓰지 않음)
        if (!sel || isDeskEntry(sel)) { setHist({ loading: false, mode: '', rows: [], missing: 0, err: '' }); return undefined; }
        let alive = true;
        setHist(h => ({ ...h, loading: true, err: '' }));
        loadOrderHistory(clinicId, sel).then(r => {
            if (alive) setHist({ loading: false, ...r, err: '' });
        }).catch(e => {
            console.error('[접수] 보철 이력 조회 실패:', e?.code || e?.message || e);
            if (alive) setHist({ loading: false, mode: '', rows: [], missing: 0, err: '보철 이력을 불러오지 못했습니다.' });
        });
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selId, selOrderKey, clinicId]);

    // [호출] — 누르는 즉시 「호출함」으로 내리고, 실패하면 되돌림 + 문구
    const doCall = async (it) => {
        if (!it || it._temp || inflightRef.current.has(it.id)) return;
        inflightRef.current.add(it.id);
        const prevStatus = it.status;
        const prevCalledAt = it.calledAt;
        optRef.current.called.set(it.id, Date.now());
        setItems(prev => prev.map(x => x.id === it.id ? { ...x, status: 'called', calledAt: Date.now() } : x));
        showToast(`${it.name} 님을 호출했습니다`);
        try {
            const r = await timed('reception', '호출', () => callReception(it.id));
            if (r?.calledAt) {
                optRef.current.called.set(it.id, r.calledAt);
                setItems(prev => prev.map(x => x.id === it.id ? { ...x, calledAt: r.calledAt } : x));
            }
            loadToday();
        } catch (e) {
            console.error('[접수] 호출 실패:', e?.code || e?.message || e, e?.details?.code || '');
            optRef.current.called.delete(it.id);
            setItems(prev => prev.map(x => x.id === it.id ? { ...x, status: prevStatus, calledAt: prevCalledAt } : x));
            showToast(receptionDeskError(e, '호출하지 못했습니다. 다시 눌러 주세요.'));
        } finally {
            inflightRef.current.delete(it.id);
        }
    };

    // ── 데스크 직접 추가 (대표·직원) — 그날 대기 맨 뒤
    //  누르는 즉시 입력부를 닫고 임시 행(「넣는 중」 작은 표시)을 맨 뒤에 붙인다 → 서버 응답 id 로 교체 → 폴링 목록에 나타나면 임시 행 해제.
    //  실패 시 임시 행 제거 + 입력부를 같은 값으로 다시 열고 문구
    const closeAdd = () => { setAddOpen(false); setAddName(''); setAddReason(''); setAddErr(''); };
    const tmpSeq = useRef(0);
    const doAdd = async () => {
        const nm = normName(addName);
        if (!isValidReceptionName(nm)) { setAddErr(`이름을 확인해 주세요 (${RECEPTION_NAME_HINT}).`); return; }
        const reason = addReason || null;
        tmpSeq.current += 1;
        const tmpId = `tmp_${Date.now()}_${tmpSeq.current}`;
        const temp = { row: { id: tmpId, name: nm, reason, at: Date.now(), status: 'wait', source: 'desk', desk: true, kind: null, guardian: false, _temp: true }, serverId: null };
        optRef.current.temps.push(temp);
        setItems(prev => [...prev, temp.row]);
        closeAdd();
        try {
            const r = await timed('reception', '직접 추가', () => addDeskWalkin(nm, reason));
            if (r?.id) {
                temp.serverId = r.id;
                setItems(prev => prev.map(x => x.id === tmpId ? { ...x, id: r.id, _temp: false } : x));
            } else {
                optRef.current.temps = optRef.current.temps.filter(t => t !== temp);
                setItems(prev => prev.filter(x => x.id !== tmpId));
            }
            showToast(Number(r?.order) > 0 ? `${nm} 님을 대기 ${r.order}번째에 넣었습니다` : `${nm} 님을 대기 맨 뒤에 넣었습니다`);
            loadToday();
        } catch (e) {
            console.error('[접수] 데스크 직접 추가 실패:', e?.code || e?.message || e, e?.details?.code || '');
            optRef.current.temps = optRef.current.temps.filter(t => t !== temp);
            setItems(prev => prev.filter(x => x.id !== tmpId));
            setAddOpen(true); setAddName(nm); setAddReason(reason || '');
            setAddErr(receptionDeskAddError(e));
        }
    };

    // ── 데스크 추가 건 빼기 (대표·직원, 화면 안 확인 1단계) — 확인 [빼기] 즉시 목록에서 빼고, 실패 시 되돌림 + 문구
    const doRemove = async (it) => {
        if (!it || !rm || rm.id !== it.id || rm.busy || it._temp) return;
        const idx = items.findIndex(x => x.id === it.id);
        optRef.current.removed.add(it.id);
        setRm(null);
        if (selId === it.id) setSelId(null);
        setItems(prev => prev.filter(x => x.id !== it.id));
        showToast(`${it.name} 님을 대기에서 뺐습니다`);
        try {
            await timed('reception', '빼기', () => removeDeskWalkin(it.id));
            loadToday();
        } catch (e) {
            console.error('[접수] 데스크 추가 빼기 실패:', e?.code || e?.message || e, e?.details?.code || '');
            optRef.current.removed.delete(it.id);
            if (e?.details?.code === 'reception-not-found') { loadToday(); showToast(receptionDeskRemoveError(e)); return; }
            setItems(prev => {
                if (prev.some(x => x.id === it.id)) return prev;
                const next = [...prev];
                next.splice(idx < 0 ? next.length : Math.min(idx, next.length), 0, it);
                return next;
            });
            setRm({ id: it.id, busy: false, err: receptionDeskRemoveError(e) });
        }
    };

    const copy = async (key, text) => {
        try {
            await navigator.clipboard.writeText(String(text || ''));
            setCopied(key);
            setTimeout(() => setCopied(c => (c === key ? '' : c)), 1200);
        } catch (e) {
            console.error('[접수] 복사 실패:', e?.name || e?.message || e);
            showToast('복사하지 못했습니다. 직접 선택해 복사해 주세요.');
        }
    };

    // ── 접수 기록 캘린더
    const nowK = kstParts(now);
    const [calYm, setCalYm] = useState(() => { const p = kstParts(new Date()); return { y: p.y, m: p.m }; });
    const ymKey = `${calYm.y}-${pad(calYm.m)}`;
    const [monthDays, setMonthDays] = useState({});
    const [monthErr, setMonthErr] = useState('');
    const isThisMonth = calYm.y === nowK.y && calYm.m === nowK.m;
    const todayCountForMonth = isThisMonth ? items.length : -1;   // 이번 달이면 오늘 접수 수가 바뀔 때 다시 센다

    useEffect(() => {
        let alive = true;
        listReceptionMonth(ymKey).then(r => {
            if (!alive) return;
            setMonthDays(r?.days && typeof r.days === 'object' ? r.days : {});
            setMonthErr('');
        }).catch(e => {
            console.error('[접수] 월 기록 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
            if (alive) { setMonthDays({}); setMonthErr(receptionDeskError(e, '접수 기록을 불러오지 못했습니다.')); }
        });
        return () => { alive = false; };
    }, [ymKey, todayCountForMonth, listRev]);

    const calMove = (dlt) => {
        if (dlt === 0) { const p = kstParts(new Date()); setCalYm({ y: p.y, m: p.m }); return; }
        const x = new Date(calYm.y, calYm.m - 1 + dlt, 1);
        setCalYm({ y: x.getFullYear(), m: x.getMonth() + 1 });
    };

    const [hDay, setHDay] = useState(null);
    const [dayItems, setDayItems] = useState({ loading: false, list: [], err: '' });
    const [hQuery, setHQuery] = useState('');
    const [search, setSearch] = useState({ loading: false, q: '', list: [], err: '', truncated: false });
    const [hSel, setHSel] = useState(null);   // 접수 기록 항목(date 포함)
    const [hCard, setHCard] = useState({ loading: false, data: null, err: '' });
    const [hSame, setHSame] = useState({ loading: false, list: [], err: '' });
    const [hOrders, setHOrders] = useState({ loading: false, mode: '', rows: [], missing: 0, err: '' });

    useEffect(() => {
        if (!hDay) { setDayItems({ loading: false, list: [], err: '' }); return undefined; }
        let alive = true;
        setDayItems({ loading: true, list: [], err: '' });
        listReceptionDay(hDay).then(r => {
            if (alive) setDayItems({ loading: false, list: (Array.isArray(r?.items) ? r.items : []).map(x => ({ ...x, date: x.date || hDay })), err: '' });
        }).catch(e => {
            console.error('[접수] 날짜별 기록 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
            if (alive) setDayItems({ loading: false, list: [], err: receptionDeskError(e, '그날 접수 목록을 불러오지 못했습니다.') });
        });
        return () => { alive = false; };
    }, [hDay, listRev]);

    // 이름 검색 — 입력 후 0.5초 디바운스, 전체 날짜
    useEffect(() => {
        const q = normName(hQuery);
        if (!q) { setSearch({ loading: false, q: '', list: [], err: '', truncated: false }); return undefined; }
        let alive = true;
        setSearch(s => ({ ...s, loading: true, q }));
        const t = setTimeout(() => {
            searchReceptionHistory(q).then(r => {
                if (!alive) return;
                const list = (Array.isArray(r?.items) ? r.items : []).slice()
                    .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) || String(fmtHM(b.at)).localeCompare(String(fmtHM(a.at))));
                setSearch({ loading: false, q, list, err: '', truncated: r?.truncated === true });
            }).catch(e => {
                console.error('[접수] 이름 검색 실패:', e?.code || e?.message || e, e?.details?.code || '');
                if (alive) setSearch({ loading: false, q, list: [], err: receptionDeskError(e, '검색하지 못했습니다.'), truncated: false });
            });
        }, 500);
        return () => { alive = false; clearTimeout(t); };
    }, [hQuery]);

    const hits = useMemo(() => {
        if (!search.q) return null;
        const out = {};
        search.list.forEach(x => { if (x.date) out[x.date] = (out[x.date] || 0) + 1; });
        return out;
    }, [search]);

    const hSelKey = hSel ? `${hSel.date}#${hSel.id}` : '';
    useEffect(() => {
        if (!hSel) {
            setHCard({ loading: false, data: null, err: '' });
            setHSame({ loading: false, list: [], err: '' });
            setHOrders({ loading: false, mode: '', rows: [], missing: 0, err: '' });
            return undefined;
        }
        let alive = true;
        if (needsDetail(hSel)) {
            setHCard({ loading: true, data: null, err: '' });
            getReceptionDetail(hSel.id).then(r => { if (alive) setHCard({ loading: false, data: r?.card || null, err: r?.card ? '' : '접수 카드 내용이 없습니다.' }); })
                .catch(e => {
                    console.error('[접수] 지난 접수 카드 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
                    if (alive) setHCard({ loading: false, data: null, err: receptionDeskError(e, '접수 카드를 불러오지 못했습니다.') });
                });
        } else setHCard({ loading: false, data: null, err: '' });
        setHSame({ loading: true, list: [], err: '' });
        searchReceptionHistory(hSel.name).then(r => {
            if (!alive) return;
            const nm = normName(hSel.name);
            const list = (Array.isArray(r?.items) ? r.items : []).filter(x => normName(x.name) === nm)
                .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) || String(fmtHM(b.at)).localeCompare(String(fmtHM(a.at))));
            setHSame({ loading: false, list, err: '' });
        }).catch(e => {
            console.error('[접수] 같은 이름 기록 조회 실패:', e?.code || e?.message || e, e?.details?.code || '');
            if (alive) setHSame({ loading: false, list: [], err: receptionDeskError(e, '같은 이름 기록을 불러오지 못했습니다.') });
        });
        setHOrders(h => ({ ...h, loading: true, err: '' }));
        loadOrderHistory(clinicId, hSel).then(r => { if (alive) setHOrders({ loading: false, ...r, err: '' }); })
            .catch(e => {
                console.error('[접수] 지난 보철 이력 조회 실패:', e?.code || e?.message || e);
                if (alive) setHOrders({ loading: false, mode: '', rows: [], missing: 0, err: '보철 이력을 불러오지 못했습니다.' });
            });
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hSelKey, clinicId]);

    // ── 30초 무조작 자동 닫힘
    const openAny = !!selId || !!hSel;
    const left = RECEPTION_AUTO_CLOSE_SEC - Math.floor((now.getTime() - lastActRef.current) / 1000);
    useEffect(() => {
        if (openAny && left <= 0) {
            setSelId(null); setHSel(null); setDel(null);
            setCard({ loading: false, data: null, err: '' }); setHCard({ loading: false, data: null, err: '' });
            showToast('30초 동안 조작이 없어 환자 정보를 닫았습니다');
        }
    }, [openAny, left, showToast]);
    const touch = () => { lastActRef.current = Date.now(); };

    // ── 접수 삭제 (대표만) — 서버 응답 { ok:true, unlinkedOrders }
    //  누르는 즉시 상세를 닫고 목록에서 뺀다. 실패 시 목록 되돌림(다시 불러오기) + 문구(토스트 — 상세 칸은 이미 닫혀 있음)
    const doDelete = async () => {
        const d = del;
        if (!d || d.busy || !d.reason) return;
        optRef.current.removed.add(d.id);
        setDel(null);
        // 같은 접수가 오늘·기록 양쪽에 열려 있을 수 있어 둘 다 닫는다
        if (selId === d.id) { setSelId(null); setCard({ loading: false, data: null, err: '' }); }
        if (hSel && hSel.id === d.id) { setHSel(null); setHCard({ loading: false, data: null, err: '' }); }
        const prevItems = items;
        const prevSearchList = search.list;
        setItems(prev => prev.filter(x => x.id !== d.id));
        setSearch(s => ({ ...s, list: s.list.filter(x => x.id !== d.id) }));
        showToast('삭제했습니다');
        try {
            await timed('reception', '삭제', () => deleteReceptionEntry(d.id, d.reason));
            loadToday();
            setListRev(v => v + 1);
        } catch (e) {
            console.error('[접수] 접수 삭제 실패:', e?.code || e?.message || e, e?.details?.code || '');
            optRef.current.removed.delete(d.id);
            if (e?.details?.code !== 'reception-not-found') {
                setItems(cur => (cur.some(x => x.id === d.id) ? cur : prevItems));
                setSearch(s => ({ ...s, list: s.list.some(x => x.id === d.id) ? s.list : prevSearchList }));
            }
            // 이미 없는 접수 — 목록을 다시 불러와 화면을 맞춘다. 그 외 실패도 서버 목록으로 다시 맞춘다
            loadToday(); setListRev(v => v + 1);
            showToast(receptionDeleteError(e));
        }
    };

    // ── 렌더 조각
    const serverNotReady = listErr && listErr.startsWith('접수 서버 준비 중');
    // 구분 배지 — 데스크 추가 건은 '처음/기존' 대신 「데스크 추가」(kind:null 을 '기존 환자'로 잘못 보이지 않게)
    const chip = (it) => (isDeskEntry(it)
        ? <span style={S.chipDesk}>{receptionKindLabelOf(it)}</span>
        : <>
            <span style={it?.kind === 'new' ? S.chipNew : S.chipOld}>{kindLabel(it?.kind)}</span>
            {isAppEntry(it) && <span style={S.chipDesk}>{APP_RECEPTION_BADGE}</span>}
        </>);
    // 접수 경로 문구 — 앱 접수면 '앱 접수', 아니면 종전 'QR 접수'
    const viaText = (it) => (isAppEntry(it) ? APP_RECEPTION_BADGE : 'QR 접수');
    // 보호자(만 14세 미만) 접수 배지 — 목록에는 아이 이름만, 보호자 이름·관계는 상세에서만(대표 10-04: §7-5 A안 데스크 대면 확인)
    const guardChip = (it) => (it && it.guardian === true ? <span style={S.chipGuard}>{GUARDIAN_BADGE}</span> : null);
    const orderOf = (it) => waitList.findIndex(x => x.id === it.id) + 1;

    const queueRow = (it, i) => {
        const called = it.status === 'called';
        const on = selId === it.id;
        const fresh = freshIds.includes(it.id);
        const desk = isDeskEntry(it);
        const confirming = desk && rm && rm.id === it.id;
        return (
            <div key={it.id} role="button" tabIndex={0} onClick={() => { if (!it._temp) pick(it.id); }} onKeyDown={(e) => { if (e.key === 'Enter' && !it._temp) pick(it.id); }}
                style={{ ...S.row, ...(on ? S.rowOn : null), ...(called ? S.rowCalled : null), ...(fresh ? S.rowFresh : null) }}>
                <span style={{ ...S.no, ...(called ? S.noCalled : null) }}>{called ? '·' : i + 1}</span>
                <span style={S.nm}>{it.name}</span>
                {chip(it)}
                {guardChip(it)}
                <span style={S.sub}>{it.reason ? reasonLabel(it.reason) : '-'}</span>
                <span style={S.tm}>{fmtHM(it.at)}</span>
                {it._temp
                    ? <span style={S.sub}>{'넣는 중'}</span>
                    : called
                    ? <span style={S.chipCall}>호출함</span>
                    : <button type="button" onClick={(e) => { e.stopPropagation(); doCall(it); }} style={S.btnSmPri}>호출</button>}
                {desk && !confirming && !it._temp && (
                    <button type="button" onClick={(e) => { e.stopPropagation(); setRm({ id: it.id, busy: false, err: '' }); }} style={S.btnSmDanger}>빼기</button>
                )}
                {confirming && (
                    <div style={S.rmBox} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()} role="presentation">
                        <span style={S.rmText}>{`${it.name} 님을 대기에서 뺄까요?`}</span>
                        <button type="button" onClick={() => doRemove(it)} style={S.btnSmDangerFill}>빼기</button>
                        <button type="button" disabled={rm.busy} onClick={() => setRm(null)} style={S.btnSm}>취소</button>
                        {rm.err && <div style={{ ...S.errNote, flexBasis: '100%' }}>{rm.err}</div>}
                    </div>
                )}
            </div>
        );
    };

    const historyBlock = (h, emptyText) => {
        if (h.loading) return <div style={S.subPad}>불러오는 중…</div>;
        if (h.err) return <div style={S.errNote}>{h.err}</div>;
        const linked = h.mode === 'linked';
        return (
            <>
                {h.rows.length ? h.rows.map(o => (
                    <div key={o.id} style={S.kv}>
                        <span style={{ ...S.k, fontFamily: S.mono, fontSize: 12.5 }}>{o.date}</span>
                        <span style={S.v}>{o.text}{o.tail ? <span style={S.sub}>{` · ${o.tail}`}</span> : null}</span>
                    </div>
                )) : <div style={S.subPad}>{emptyText}</div>}
                {linked && h.missing > 0 && <div style={S.note}>{`연결된 의뢰서 중 ${h.missing}건은 찾을 수 없습니다(삭제되었거나 볼 수 없는 의뢰서).`}</div>}
                {!linked && h.rows.length > 0 && <div style={S.noteWarn}>이름으로만 찾은 결과라 동명이인일 수 있습니다. 차트로 같은 분인지 확인해 주세요.</div>}
            </>
        );
    };
    const historyTitle = (h) => (
        <h3 style={S.h3}>보철 이력 <span style={S.sub}>{h.mode === 'linked' ? '의뢰서 연결됨' : '이 이름으로 보낸 의뢰서'}</span></h3>
    );

    // 기존 환자 보호자 접수 — 상세(접속기록) 조회 결과의 보호자 이름·관계
    const guardianSec = (cd) => (
        <div style={S.sec}>
            <h3 style={S.h3}>보호자 <span style={S.sub}>만 14세 미만 · 부모 또는 후견인이 대신 접수</span></h3>
            {cd.loading ? <div style={S.subPad}>불러오는 중…</div> : cd.err ? <div style={S.errNote}>{cd.err}</div> : (
                <>
                    <div style={S.kv}><span style={S.k}>보호자</span><span style={S.v}>{cd.data?.guardian ? guardianLine(cd.data.guardian) : '-'}</span></div>
                    <div style={S.noteWarn}>{GUARDIAN_DESK_NOTE}</div>
                </>
            )}
        </div>
    );

    // 상세 칸 맨 아래 [이 접수 삭제] — 대표만. 사유 선택 → 화면 안 확인 → 삭제
    const deleteSec = (panel, target) => {
        // 데스크 추가 건은 줄의 [빼기](대표·직원)로 뺀다 — QR 접수 삭제(대표·사유) 경로 아님
        if (!isOwner || !target?.id || isDeskEntry(target)) return null;
        const d = del && del.panel === panel && del.id === target.id ? del : null;
        if (!d) {
            return (
                <div style={S.sec}>
                    <button type="button" onClick={() => setDel({ panel, id: target.id, reason: '', step: 'pick', busy: false, err: '' })} style={S.btnDanger}>이 접수 삭제</button>
                </div>
            );
        }
        return (
            <div style={{ ...S.sec, ...S.delBox }}>
                <h3 style={S.h3}>이 접수 삭제 <span style={S.sub}>치과 대표만 · 되돌릴 수 없음</span></h3>
                {d.step === 'pick' ? (
                    <>
                        <div style={{ fontSize: 13, color: '#46524e', margin: '4px 0 8px' }}>삭제 사유를 골라 주세요.</div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                            {RECEPTION_DELETE_REASONS.map(r => (
                                <button key={r.key} type="button" onClick={() => setDel({ ...d, reason: r.key, err: '' })}
                                    style={d.reason === r.key ? S.btnSmPri : S.btnSm}>{r.label}</button>
                            ))}
                        </div>
                        <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                            <button type="button" disabled={!d.reason} onClick={() => setDel({ ...d, step: 'confirm', err: '' })}
                                style={{ ...S.btnDanger, ...(d.reason ? null : { opacity: 0.5, cursor: 'default' }) }}>다음</button>
                            <button type="button" onClick={() => setDel(null)} style={S.btnSm}>취소</button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={S.delWarn}>{`${target.name} 님 접수 (사유: ${(RECEPTION_DELETE_REASONS.find(r => r.key === d.reason) || {}).label || '-'})`}<br />삭제하면 되돌릴 수 없습니다. 연결된 의뢰서 표시도 함께 지워집니다.</div>
                        <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                            <button type="button" disabled={d.busy} onClick={doDelete} style={S.btnDangerFill}>{d.busy ? '삭제 중…' : '삭제'}</button>
                            <button type="button" disabled={d.busy} onClick={() => setDel({ ...d, step: 'pick', err: '' })} style={S.btnSm}>이전</button>
                            <button type="button" disabled={d.busy} onClick={() => setDel(null)} style={S.btnSm}>취소</button>
                        </div>
                    </>
                )}
                {d.err && <div style={S.errNote}>{d.err}</div>}
            </div>
        );
    };

    const renderPanel = () => {
        if (!sel) {
            return <div style={S.empty}>왼쪽 대기 순서에서 이름을 누르면<br />처음 온 환자는 <b>접수 카드</b>, 기존 환자는 <b>보철 이력</b>이 보입니다.</div>;
        }
        const called = sel.status === 'called';
        // 데스크 추가 건 — 이름·오신 이유만. 상세 조회·보철 이력(이름 검색) 호출 없음
        if (isDeskEntry(sel)) {
            return (
                <>
                    <div style={S.flexRow}>
                        <span style={S.pname}>{sel.name}</span>{chip(sel)}
                        <button type="button" onClick={() => setSelId(null)} style={{ ...S.btnSm, marginLeft: 'auto' }}>닫기</button>
                    </div>
                    <div style={{ ...S.sub, marginTop: 4 }}>
                        {`${fmtHM(sel.at)} 데스크 추가 · ${sel.reason ? reasonLabel(sel.reason) : '오신 이유 없음'}${called ? ` · ${fmtHM(sel.calledAt)} 호출함` : ` · 대기 ${orderOf(sel)}번째`}`}
                    </div>
                    {!called && <div style={{ marginTop: 10 }}><button type="button" onClick={() => doCall(sel)} style={S.btnPri}>호출</button></div>}
                    <div style={S.note}>{DESK_ADD_PANEL_NOTE}</div>
                </>
            );
        }
        const c = card.data || {};
        const rows = [['이름', c.name || sel.name], ['생년월일', c.birth], ['성별', c.sex ? sexLabel(c.sex) : ''], ['휴대폰', c.tel], ['주소', c.addr], ['오신 이유', reasonLabel(c.reason || sel.reason)]];
        if (c.guardian) rows.push(['보호자', guardianLine(c.guardian)]);
        return (
            <>
                <div style={S.flexRow}>
                    <span style={S.pname}>{sel.name}</span>{chip(sel)}{guardChip(sel)}
                    <button type="button" onClick={() => setSelId(null)} style={{ ...S.btnSm, marginLeft: 'auto' }}>닫기</button>
                </div>
                <div style={{ ...S.sub, marginTop: 4 }}>
                    {`${fmtHM(sel.at)} ${viaText(sel)} · ${reasonLabel(sel.reason)}${called ? ` · ${fmtHM(sel.calledAt)} 호출함` : ` · 대기 ${orderOf(sel)}번째`}`}
                </div>
                {!called && <div style={{ marginTop: 10 }}><button type="button" onClick={() => doCall(sel)} style={S.btnPri}>호출</button></div>}
                {sel.kind === 'new' ? (
                    <>
                        <div style={S.sec}>
                            <h3 style={S.h3}>접수 카드 <span style={S.sub}>환자가 직접 적은 내용 · 전자차트 신환 등록에 옮겨 적기</span></h3>
                            {card.loading ? <div style={S.subPad}>불러오는 중…</div> : card.err ? <div style={S.errNote}>{card.err}</div> : (
                                <>
                                    {rows.map(([k, v]) => (
                                        <div key={k} style={S.kv}>
                                            <span style={S.k}>{k}</span>
                                            <span style={S.v}>{v || '-'}</span>
                                            <button type="button" onClick={() => copy(`${sel.id}:${k}`, v)} style={S.btnSm}>{copied === `${sel.id}:${k}` ? '복사됨' : '복사'}</button>
                                        </div>
                                    ))}
                                    {c.guardian && <div style={S.noteWarn}>{GUARDIAN_DESK_NOTE}</div>}
                                    <div style={S.note}>휴대폰 번호는 인증하지 않은 번호입니다. 전자차트에 등록할 때 한 번 확인해 주세요.</div>
                                </>
                            )}
                        </div>
                        {/* 처음 온 환자도 의뢰서가 연결되면 보철 이력을 보인다(2026-10-03 추가 지시) */}
                        {hist.mode === 'linked' && <div style={S.sec}>{historyTitle(hist)}{historyBlock(hist, '연결된 의뢰서가 없습니다.')}</div>}
                    </>
                ) : (
                    <>
                        {sel.guardian === true && guardianSec(card)}
                        <div style={S.sec}>{historyTitle(hist)}{historyBlock(hist, '이 이름으로 보낸 의뢰서가 없습니다.')}</div>
                        <div style={S.note}>기존 환자는 이름과 오신 이유만 받습니다. 자정에 아래 「접수 기록」 캘린더로 옮겨져 2년 보관됩니다.</div>
                    </>
                )}
                {deleteSec('today', sel)}
            </>
        );
    };

    // ── [+ 직접 추가] 입력부 — 목록 위 한 줄. 사용 불가(1.2 미확인·개시일 전)면 입력 대신 안내/확인 카드
    const renderAdd = () => {
        const cc = clinicConsent;
        const fromFuture = !!cc.deskAddFrom && kstDayKey(now) < cc.deskAddFrom;
        if (cc.loading) return <div style={S.addBox}><div style={S.subPad}>불러오는 중…</div></div>;
        if (!cc.deskAddReady || fromFuture) {
            return (
                <div style={S.addBox}>
                    <div style={S.flexRow}>
                        <b style={{ fontSize: 14, color: '#17201d' }}>직접 추가</b>
                        <button type="button" onClick={closeAdd} style={{ ...S.btnSm, marginLeft: 'auto' }}>닫기</button>
                    </div>
                    {fromFuture && <div style={S.noteWarn}>{`직접 추가는 ${fmtMonthDay(cc.deskAddFrom)}부터 사용할 수 있습니다.`}</div>}
                    {!cc.deskAddReady && <div style={{ marginTop: 8 }}><DeskClinicConsentCard variant="deskAdd" onState={(x) => { if (!x?.loading) setClinicConsent(x); }} /></div>}
                </div>
            );
        }
        return (
            <div style={S.addBox}>
                <div style={S.addRow}>
                    <label htmlFor="desk-add-name" style={S.addLabel}>이름</label>
                    <input id="desk-add-name" value={addName} autoFocus maxLength={20} autoComplete="off"
                        onChange={(e) => { setAddName(e.target.value); if (addErr) setAddErr(''); touch(); }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.nativeEvent.isComposing) { e.preventDefault(); doAdd(); }
                            else if (e.key === 'Escape') closeAdd();
                        }}
                        placeholder="환자 이름" aria-label="직접 추가할 환자 이름" style={S.addInput} />
                </div>
                <div style={{ ...S.addRow, marginTop: 8 }}>
                    <span style={S.addLabel}>오신 이유</span>
                    <span style={S.sub}>(안 골라도 됩니다)</span>
                    {RECEPTION_REASONS.map(r => (
                        <button key={r.key} type="button" aria-pressed={addReason === r.key}
                            onClick={() => { setAddReason(v => (v === r.key ? '' : r.key)); touch(); }}
                            style={addReason === r.key ? S.btnSmPri : S.btnSm}>{r.label}</button>
                    ))}
                </div>
                <div style={{ ...S.addRow, marginTop: 10, justifyContent: 'flex-end' }}>
                    <button type="button" onClick={closeAdd} style={S.btnSm}>취소</button>
                    <button type="button" disabled={!normName(addName)} onClick={doAdd}
                        style={{ ...S.btnPri, ...(!normName(addName) ? { opacity: 0.5, cursor: 'default' } : null) }}>추가</button>
                </div>
                {addErr && <div style={S.errNote}>{addErr}</div>}
                <div style={{ ...S.sub, marginTop: 8, lineHeight: 1.55 }}>{DESK_ADD_FORM_NOTE}</div>
            </div>
        );
    };

    const renderCal = () => {
        const first = new Date(calYm.y, calYm.m - 1, 1);
        const off = first.getDay();
        const last = new Date(calYm.y, calYm.m, 0).getDate();
        const rowsN = Math.ceil((off + last) / 7);
        const tk = kstDayKey(now);
        const cells = [];
        let monthTotal = 0;
        for (let i = 0; i < rowsN * 7; i++) {
            const d = new Date(calYm.y, calYm.m - 1, 1 - off + i);
            const k = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            const inM = d.getMonth() === calYm.m - 1;
            const info = inM ? monthDays[k] : null;   // 월 응답은 그달 날짜만
            const total = Number(info?.total) || 0;
            const nNew = Number(info?.newCount) || 0;
            if (inM) monthTotal += total;
            const hit = hits && hits[k];
            const has = total > 0;
            cells.push(
                <button key={k} type="button" disabled={!has} onClick={() => { setHDay(k); setHSel(null); setHQuery(''); touch(); }}
                    aria-label={`${d.getMonth() + 1}월 ${d.getDate()}일 접수 ${total}명`}
                    style={{ ...S.cd, ...(inM ? null : S.cdOut), ...(has ? S.cdHas : null), ...(k === tk ? S.cdToday : null), ...(k === hDay ? S.cdSel : null), ...(hit ? S.cdHit : null) }}>
                    {/* 2026-10-06 「오늘」 작업 공정 달력(ClinicProcessCalendar cellHead/countBadge)과 같은 모양 — 날짜 숫자 + 오른쪽 위 건수 배지 */}
                    <span style={S.cdHead}>
                        <span style={S.dn}>{d.getDate()}</span>
                        {has && <span style={S.cdCnt}>{`${total}명`}</span>}
                    </span>
                    {has && hit ? <span style={S.cn}>{`찾음 ${hit}`}</span> : null}
                    {nNew > 0 && <span style={S.nw}>{`처음 ${nNew}`}</span>}
                    {!has && hit ? <span style={S.cn}>{`찾음 ${hit}`}</span> : null}
                </button>
            );
        }
        return { cells, monthTotal };
    };
    const { cells, monthTotal } = renderCal();

    const hList = search.q ? search.list : dayItems.list;
    const hListTitle = search.q ? `"${search.q}" 찾은 기록` : (hDay ? `${fmtDayKey(hDay)} 접수 환자` : '날짜를 누르세요');
    const hListLoading = search.q ? search.loading : dayItems.loading;
    const hListErr = search.q ? search.err : dayItems.err;

    const renderHPanel = () => {
        if (!hSel) return <div style={S.empty}>목록에서 환자를 누르면<br />그날 접수 내용과 지난 접수 기록이 보입니다.</div>;
        const c = hCard.data || {};
        return (
            <>
                <div style={S.flexRow}><span style={S.pname}>{hSel.name}</span>{chip(hSel)}{guardChip(hSel)}
                    <button type="button" onClick={() => setHSel(null)} style={{ ...S.btnSm, marginLeft: 'auto' }}>닫기</button>
                </div>
                <div style={{ ...S.sub, marginTop: 4 }}>{`${fmtDayKey(hSel.date)} ${fmtHM(hSel.at)} ${viaText(hSel)} · ${reasonLabel(hSel.reason)}`}</div>
                {hSel.kind === 'new' && (
                    <div style={S.sec}>
                        <h3 style={S.h3}>그날 접수 카드</h3>
                        {hCard.loading ? <div style={S.subPad}>불러오는 중…</div> : hCard.err ? <div style={S.errNote}>{hCard.err}</div> :
                            [['생년월일', c.birth], ['성별', c.sex ? sexLabel(c.sex) : ''], ['휴대폰', c.tel], ['주소', c.addr], ...(c.guardian ? [['보호자', guardianLine(c.guardian)]] : [])].map(([k, v]) => (
                                <div key={k} style={S.kv}><span style={S.k}>{k}</span><span style={S.v}>{v || '-'}</span></div>
                            ))}
                    </div>
                )}
                {hSel.kind !== 'new' && hSel.guardian === true && guardianSec(hCard)}
                <div style={S.sec}>
                    <h3 style={S.h3}>같은 이름 접수 기록 <span style={S.sub}>{hSame.loading ? '' : `${hSame.list.length}건 · 동명이인일 수 있음`}</span></h3>
                    {hSame.loading ? <div style={S.subPad}>불러오는 중…</div> : hSame.err ? <div style={S.errNote}>{hSame.err}</div> :
                        hSame.list.map(x => (
                            <div key={`${x.date}#${x.id}`} style={S.kv}>
                                <span style={{ ...S.v, fontFamily: S.mono, fontSize: 13 }}>{`${fmtDayKey(x.date)} ${fmtHM(x.at)} · ${reasonLabel(x.reason)}`}</span>
                            </div>
                        ))}
                </div>
                {(hOrders.loading || hOrders.err || hOrders.rows.length > 0) && (
                    <div style={S.sec}>{historyTitle(hOrders)}{historyBlock(hOrders, '')}</div>
                )}
                {deleteSec('hist', hSel)}
            </>
        );
    };

    return (
        <div style={S.page} onMouseMove={touch} onKeyDown={touch} onClick={touch} onTouchStart={touch} onWheel={touch}>
            {/* 처리위탁 확인 — 미확인이면 데스크 위에 확인 카드. 확인 완료면 아무것도 그리지 않는다.
                1.1 확인 치과(isCurrent:false)도 QR 접수는 그대로 되므로 여기서는 재확인 카드를 그리지 않는다(showReconfirm=false) — 1.2 는 직접 추가 영역에서만 */}
            {!clinicConsent.loading && !clinicConsent.confirmed && <div style={S.gateBanner}>QR 접수가 아직 시작되지 않았습니다. 아래 처리위탁 확인을 치과 대표가 마치면 환자가 QR로 접수할 수 있습니다.</div>}
            <DeskClinicConsentCard onState={setClinicConsent} showReconfirm={false} />
            {/* 2026-10-06 접수 화면 [진료 끝] 모달 연결 비노출(대표 지시) — 환자 상세 [진료 끝 ▾](ClinicPatientDetail → CareTrackStart)로 일원화. 되살릴 때 주석 해제
            {roadmapOn && trackPick && (
                <ClinicPatientPicker clinicId={clinicId} onClose={() => setTrackPick(false)}
                    onSelect={(r) => { setTrackPick(false); setTrackTarget({ id: r.id, name: r.name, aftercareOn: r.aftercareOn === true }); }} />
            )}
            {roadmapOn && trackTarget && (
                <CareTrackStartModal pid={trackTarget.id} name={trackTarget.name} consentOn={trackTarget.aftercareOn} isOwner={isOwner} onClose={() => setTrackTarget(null)} />
            )}
            */}
            <div style={S.monitor}>
                <div style={S.mbar}>
                    <b style={{ color: '#17201d' }}>{clinicName}</b><span>접수</span>
                    {/* 2026-10-06 상단 바 오른쪽 3개(「새 앱 등록 N명」 배지·[진료 끝]·[데스크 QR 보기]) 비노출(대표 지시).
                        배지=「오늘」(/clinic-today) 카드, 진료 끝=환자 상세 [진료 끝 ▾], 데스크 QR=설정 /settings/walkin-qr 에서 그대로 사용 가능. 되살릴 때 주석 해제
                    <span style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center' }}>
                        <ClinicSelfRegisterCard clinicId={clinicId} variant="badge" />
                        {/* 🗺️ [진료 끝] — 접수 행과 자동 결합하지 않고 명부에서 환자를 고른다(계약 §2). 플래그 OFF면 비노출 *\/}
                        {roadmapOn && <button type="button" onClick={() => { setTrackPick(true); touch(); }} style={S.btnSm}>진료 끝</button>}
                        <button type="button" onClick={() => navigate('/settings/walkin-qr')} style={S.btnSm}>데스크 QR 보기</button>
                    </span>
                    */}
                </div>
                <div style={S.clock}>
                    <span style={S.clockD}>{`${nowK.y}년 ${nowK.m}월 ${nowK.d}일 (${WEEKDAYS[nowK.wd]})`}</span>
                    <span style={S.clockT}>{`${pad(nowK.hh)}:${pad(nowK.mm)}:${pad(nowK.ss)}`}</span>
                </div>

                {listErr && <div style={serverNotReady ? S.bannerErr : S.bannerWarn}>{listErr}</div>}

                <div style={S.desk}>
                    <div style={S.box}>
                        <div style={S.boxh}>
                            <h2 style={S.h2}>대기 순서</h2>
                            <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
                                {!addOpen && <button type="button" onClick={() => { setAddOpen(true); setAddErr(''); touch(); }} style={S.btnAdd}>+ 직접 추가</button>}
                                <span style={S.sub}>{`대기 ${waitList.length}명`}</span>
                            </span>
                        </div>
                        <div style={S.scroll}>
                            {addOpen && renderAdd()}
                            {!listLoaded ? <div style={S.empty}>불러오는 중…</div> : (
                                <>
                                    {waitList.length ? waitList.map(queueRow) : <div style={S.empty}>대기 중인 환자가 없습니다.<br />환자가 데스크 QR로 접수하거나 [+ 직접 추가]로 넣으면 여기에 순서대로 생깁니다.</div>}
                                    {calledList.length > 0 && <div style={S.grp}>호출함</div>}
                                    {calledList.map(it => queueRow(it, 0))}
                                </>
                            )}
                        </div>
                        <div style={S.foot}>{appReceptionOn ? 'QR 접수·앱 접수와 데스크 추가 모두 들어온 순서대로 번호가 붙습니다. [호출]하면 아래로 내려가고 뒤 번호가 당겨집니다.' : 'QR 접수와 데스크 추가 모두 들어온 순서대로 번호가 붙습니다. [호출]하면 아래로 내려가고 뒤 번호가 당겨집니다.'}</div>
                    </div>
                    <div style={S.box}>
                        <div style={S.boxh}><h2 style={S.h2}>환자 정보</h2><span style={{ ...S.sub, marginLeft: 'auto' }}>{selId ? `자동 닫힘 ${Math.max(left, 0)}초` : '이름을 누르면 여기에'}</span></div>
                        <div style={S.scroll}>{renderPanel()}</div>
                        <div style={S.foot}>{SCREEN_NOTE}</div>
                    </div>
                    {/* 🔔 원장 호출 — 윗줄 3번째 카드(같은 높이 S.box). 접수 화면 안에서는 데스크 띠 대신 이 카드 테두리가 깜빡인다 */}
                    {doctorCallOn && <DoctorCallCard clinicId={clinicId} boxStyle={S.box} headStyle={S.boxh} h2Style={S.h2} footStyle={S.foot} />}
                </div>

                <div style={S.hist}>
                    <div style={S.histh}>
                        <h2 style={S.h2}>접수 기록</h2><span style={S.sub}>접수일부터 2년 보관 · 목적: 과거 기록 조회 · 진료기록부가 아닙니다 · 데스크 추가는 그날만 보입니다</span>
                        <input value={hQuery} onChange={(e) => { setHQuery(e.target.value); setHSel(null); }} placeholder="이름으로 찾기 (전체 날짜)" aria-label="접수 기록 이름 검색" style={S.hsearch} />
                    </div>
                    <div style={S.calnav}>
                        <button type="button" onClick={() => calMove(-1)} aria-label="지난 달" style={S.btnSm}>{'‹'}</button>
                        <b style={{ minWidth: 96, textAlign: 'center' }}>{`${calYm.y}년 ${calYm.m}월`}</b>
                        <button type="button" onClick={() => calMove(1)} aria-label="다음 달" style={S.btnSm}>{'›'}</button>
                        <button type="button" onClick={() => calMove(0)} style={S.btnSm}>이번 달</button>
                        <span style={S.sub}>{`이번 달 접수 ${monthTotal}명`}</span>
                    </div>
                    {monthErr && <div style={monthErr.startsWith('접수 서버 준비 중') ? S.bannerErr : S.bannerWarn}>{monthErr}</div>}
                    <div style={S.calweek}>
                        {WEEKDAYS.map((w, i) => <div key={w} style={{ ...S.wk, ...(i === 0 ? { color: '#b3261e' } : i === 6 ? { color: '#3f51b5' } : null) }}>{w}</div>)}
                    </div>
                    <div style={S.calgrid}>{cells}</div>
                    <div style={S.hdetail}>
                        <div style={S.box}>
                            <div style={S.boxh}><h2 style={S.h2}>{hListTitle}</h2><span style={{ ...S.sub, marginLeft: 'auto' }}>{(search.q || hDay) && !hListLoading ? `${hList.length}명${search.q && search.truncated ? '+' : ''}` : ''}</span></div>
                            {/* 서버 이름 검색 상한 초과(truncated) — 일부만 온 상태 */}
                            {search.q && !search.loading && !search.err && search.truncated && (
                                <div style={{ background: '#fffbeb', borderBottom: '1px solid #fde68a', color: '#92400e', padding: '7px 12px', fontSize: 12.5 }}>
                                    {'찾은 기록이 많아 일부만 표시합니다 — 이름을 더 적어 주세요.'}
                                </div>
                            )}
                            <div style={S.scroll}>
                                {hListLoading ? <div style={S.empty}>불러오는 중…</div>
                                    : hListErr ? <div style={S.errNote}>{hListErr}</div>
                                    : hList.length ? hList.map(x => {
                                        const key = `${x.date}#${x.id}`;
                                        return (
                                            <div key={key} role="button" tabIndex={0} onClick={() => { setHSel(x); touch(); }} onKeyDown={(e) => { if (e.key === 'Enter') setHSel(x); }}
                                                style={{ ...S.row, ...(hSelKey === key ? S.rowOn : null) }}>
                                                <span style={{ ...S.nm, fontSize: 15 }}>{x.name}</span>{chip(x)}{guardChip(x)}
                                                <span style={S.sub}>{reasonLabel(x.reason)}</span>
                                                <span style={S.tm}>{`${search.q ? `${fmtDayKey(x.date)} ` : ''}${fmtHM(x.at)}`}</span>
                                            </div>
                                        );
                                    }) : <div style={S.empty}>{search.q ? '이 이름으로 접수한 기록이 없습니다.' : <>캘린더에서 숫자가 있는 날짜를 누르면<br />그날 접수한 환자 목록이 나옵니다.</>}</div>}
                            </div>
                        </div>
                        <div style={S.box}>
                            <div style={S.boxh}><h2 style={S.h2}>접수 정보</h2><span style={{ ...S.sub, marginLeft: 'auto' }}>{hSel ? `자동 닫힘 ${Math.max(left, 0)}초` : ''}</span></div>
                            <div style={S.scroll}>{renderHPanel()}</div>
                            <div style={S.foot}>{SCREEN_NOTE}</div>
                        </div>
                    </div>
                </div>
            </div>
            {toast && <div style={S.toast} role="status">{toast}</div>}
        </div>
    );
}

const MONO = 'ui-monospace, Menlo, "IBM Plex Mono", monospace';
// 상세 칸 아래 상시 안내(정본 §3-5, 비해시)
const SCREEN_NOTE = '환자 정보가 보이는 화면입니다. 대기실·환자 쪽에서 보이지 않게 두세요. 30초 동안 조작이 없으면 이 칸은 닫힙니다.';
// 보호자 표시 — 상세에서만(접속기록 남는 경로)
const GUARDIAN_BADGE = '보호자 접수 · 동행 확인';
const GUARDIAN_DESK_NOTE = '보호자 접수(만 14세 미만) — 호명할 때 부모 또는 후견인이 함께 왔는지 확인해 주세요. 확인되지 않으면 데스크에서 다시 접수해 주세요.';
// 데스크 직접 추가 안내(비해시) — 처리위탁 1.2: 그날 대기 순서에만, 자정 마감 뒤 삭제, 접수 기록·검색·연결 제외 / 5항⑦ 이름·이유만
const DESK_ADD_FORM_NOTE = '데스크에서 받은 환자를 오늘 대기 순서 맨 뒤에 넣습니다. 오늘 밤 12시에 마감되고 그 뒤 자동으로 지워지며, 접수 기록에는 남지 않습니다. 이름 칸에는 이름만 적어 주세요(증상·연락처·주민등록번호 금지).';
const DESK_ADD_PANEL_NOTE = '데스크에서 직접 추가한 환자입니다. 이름과 오신 이유만 있고 접수 카드는 없습니다. 오늘 밤 12시 마감 뒤 자동으로 지워지며 접수 기록·의뢰서 연결에 쓰이지 않습니다. 잘못 넣었으면 대기 순서 줄의 [빼기]를 눌러 주세요.';
// 상세(접속기록) 조회가 필요한 항목 — 처음 온 환자 카드, 또는 보호자 접수(서버 목록 item.guardian === true). 데스크 추가 건은 항상 제외(카드 없음)
const needsDetail = (it) => !!it && !isDeskEntry(it) && (it.kind === 'new' || it.guardian === true);
const guardianLine = (g) => `${String(g?.name || '').trim() || '-'} (${guardianRelationLabel(g?.relation)})`;
// 시뮬레이터 팔레트 — accent #0f6b5c, new #3f51b5, call #b3261e, warn #9a5b00
const S = {
    mono: MONO,
    page: { padding: 16, maxWidth: 1280, margin: '0 auto' },
    monitor: { background: '#ffffff', border: '1px solid #d9dfdc', borderRadius: 10, overflow: 'hidden' },
    mbar: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', borderBottom: '1px solid #d9dfdc', background: '#f5f7f6', fontSize: 12.5, color: '#46524e', flexWrap: 'wrap' },
    clock: { display: 'flex', alignItems: 'baseline', gap: '6px 18px', flexWrap: 'wrap', padding: '14px 18px 10px' },
    clockD: { fontSize: 20, fontWeight: 600, color: '#46524e' },
    clockT: { fontFamily: MONO, fontSize: 42, fontWeight: 600, fontVariantNumeric: 'tabular-nums', letterSpacing: '.02em', lineHeight: 1.1, color: '#17201d' },
    desk: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 12, padding: '0 14px 14px' },
    box: { border: '1px solid #d9dfdc', borderRadius: 8, display: 'flex', flexDirection: 'column', height: 520, minWidth: 0, background: '#fff' },
    boxh: { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderBottom: '1px solid #d9dfdc', flexWrap: 'wrap' },
    h2: { fontSize: 15, margin: 0, color: '#17201d' },
    h3: { fontSize: 13.5, margin: '0 0 4px', display: 'flex', gap: 6, alignItems: 'baseline', flexWrap: 'wrap', color: '#17201d' },
    scroll: { flex: 1, minHeight: 0, overflowY: 'auto', padding: '8px 10px', overscrollBehavior: 'contain' },
    foot: { padding: '8px 12px', borderTop: '1px solid #d9dfdc', fontSize: 12, color: '#7a8783' },
    sub: { fontSize: 12, color: '#7a8783' },
    subPad: { fontSize: 12.5, color: '#7a8783', padding: '6px 0' },
    grp: { fontSize: 11.5, fontWeight: 600, color: '#7a8783', letterSpacing: '.04em', margin: '8px 4px 6px' },
    row: { display: 'flex', alignItems: 'center', gap: 8, padding: '9px 10px', border: '1px solid #d9dfdc', borderRadius: 8, marginBottom: 6, cursor: 'pointer', background: '#fff', flexWrap: 'wrap' },
    rowOn: { borderColor: '#0f6b5c', background: '#e2f0ec' },
    rowCalled: { opacity: 0.6 },
    rowFresh: { background: '#fff3dc' },
    no: { width: 26, height: 26, borderRadius: '50%', background: '#0f6b5c', color: '#fff', fontFamily: MONO, fontWeight: 600, fontSize: 13, display: 'grid', placeItems: 'center', flexShrink: 0 },
    noCalled: { background: '#d9dfdc', color: '#7a8783' },
    nm: { fontSize: 16, fontWeight: 700, color: '#17201d' },
    chipNew: { fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 999, whiteSpace: 'nowrap', background: '#e8eaf8', color: '#3f51b5' },
    chipOld: { fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 999, whiteSpace: 'nowrap', background: '#eceff0', color: '#5d6b66' },
    chipGuard: { fontSize: 11, fontWeight: 700, padding: '1px 8px', borderRadius: 999, whiteSpace: 'nowrap', background: '#fff3dc', color: '#9a5b00', border: '1px solid #f3d9a4' },
    chipDesk: { fontSize: 11, fontWeight: 600, padding: '0 8px', borderRadius: 999, whiteSpace: 'nowrap', background: '#fff', color: '#46524e', border: '1px solid #9aa6a2' },
    chipCall: { fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 999, whiteSpace: 'nowrap', background: '#fde8e6', color: '#b3261e' },
    tm: { marginLeft: 'auto', fontFamily: MONO, fontSize: 12.5, color: '#7a8783', fontVariantNumeric: 'tabular-nums' },
    btnSm: { border: '1px solid #d9dfdc', background: '#fff', color: '#17201d', borderRadius: 7, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 500 },
    btnSmPri: { border: '1px solid #0f6b5c', background: '#0f6b5c', color: '#fff', borderRadius: 7, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 },
    btnSmDanger: { border: '1px solid #e7b4b0', background: '#fff', color: '#b3261e', borderRadius: 7, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 },
    btnSmDangerFill: { border: '1px solid #b3261e', background: '#b3261e', color: '#fff', borderRadius: 7, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 },
    rmBox: { flexBasis: '100%', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginTop: 4, padding: '7px 9px', border: '1px solid #f5cfcf', background: '#fffafa', borderRadius: 7, cursor: 'default' },
    rmText: { fontSize: 13, color: '#8a2020', fontWeight: 600, marginRight: 4 },
    btnAdd: { border: '1px solid #0f6b5c', background: '#fff', color: '#0f6b5c', borderRadius: 7, padding: '4px 12px', fontSize: 13, cursor: 'pointer', fontWeight: 700 },
    addBox: { border: '1px solid #0f6b5c', background: '#f3faf8', borderRadius: 8, padding: '10px 12px', marginBottom: 10 },
    addRow: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
    addLabel: { fontSize: 13, fontWeight: 700, color: '#17201d', minWidth: 52 },
    addInput: { flex: '1 1 180px', minWidth: 0, padding: '7px 10px', border: '1px solid #9aa6a2', borderRadius: 7, fontSize: 15, color: '#17201d', fontFamily: 'inherit' },
    btnDanger: { border: '1px solid #e7b4b0', background: '#fff', color: '#b3261e', borderRadius: 7, padding: '4px 12px', fontSize: 12.5, cursor: 'pointer', fontWeight: 600 },
    btnDangerFill: { border: '1px solid #b3261e', background: '#b3261e', color: '#fff', borderRadius: 7, padding: '4px 14px', fontSize: 12.5, cursor: 'pointer', fontWeight: 600 },
    delBox: { border: '1px solid #f5cfcf', background: '#fffafa', borderRadius: 8, padding: '10px 12px' },
    delWarn: { fontSize: 13, color: '#8a2020', lineHeight: 1.6, fontWeight: 600 },
    btnPri: { border: '1px solid #0f6b5c', background: '#0f6b5c', color: '#fff', borderRadius: 7, padding: '6px 14px', fontSize: 13, cursor: 'pointer', fontWeight: 600 },
    empty: { display: 'grid', placeItems: 'center', textAlign: 'center', color: '#7a8783', height: '100%', padding: 20, lineHeight: 1.7, fontSize: 13 },
    flexRow: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
    pname: { fontSize: 24, fontWeight: 700, color: '#17201d' },
    kv: { display: 'flex', gap: 10, alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #d9dfdc', fontSize: 13.5 },
    k: { width: 84, color: '#7a8783', flexShrink: 0 },
    v: { flex: 1, minWidth: 0, color: '#17201d', wordBreak: 'break-all' },
    sec: { marginTop: 14 },
    note: { fontSize: 12, color: '#46524e', background: '#f5f7f6', border: '1px solid #d9dfdc', borderRadius: 7, padding: '8px 10px', marginTop: 10, lineHeight: 1.55 },
    noteWarn: { fontSize: 12, color: '#9a5b00', background: '#fff3dc', borderRadius: 7, padding: '8px 10px', marginTop: 10, lineHeight: 1.55 },
    errNote: { fontSize: 12.5, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 7, padding: '8px 10px', marginTop: 6, lineHeight: 1.55 },
    bannerErr: { margin: '0 14px 12px', fontSize: 13, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 8, padding: '9px 12px', fontWeight: 600 },
    bannerWarn: { margin: '0 14px 12px', fontSize: 13, color: '#9a5b00', background: '#fff3dc', borderRadius: 8, padding: '9px 12px' },
    hist: { borderTop: '1px solid #d9dfdc', padding: '12px 14px 14px', display: 'grid', gap: 10 },
    histh: { display: 'flex', alignItems: 'center', gap: '8px 12px', flexWrap: 'wrap' },
    hsearch: { marginLeft: 'auto', minWidth: 220, flex: '0 1 300px', padding: '7px 10px', border: '1px solid #d9dfdc', borderRadius: 7, fontSize: 14, color: '#17201d', fontFamily: 'inherit' },
    calnav: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 14, color: '#17201d' },
    // 2026-10-06 대표 캡처 기준: 「오늘」 작업 공정 달력(ClinicProcessCalendar.js C.cell/cellHead/countBadge 모양)과 같은 셀 크기 — 셀 높이 104·날짜 13 bold·간격 4 (레티나 2배 캡처 환산). 고정 높이 없음(주 수만큼 S.hist가 늘어남)
    calweek: { display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: 4, marginBottom: 4 },
    wk: { fontSize: 11, fontWeight: 700, textAlign: 'center', color: '#7a8783', padding: '4px 0' },
    calgrid: { display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: 4 },
    cd: { minHeight: 104, border: '1px solid #d9dfdc', borderRadius: 8, padding: '6px 7px', background: '#fff', textAlign: 'left', fontFamily: 'inherit', color: '#17201d', display: 'flex', flexDirection: 'column', gap: 3, cursor: 'default', minWidth: 0, overflow: 'hidden' },
    cdHead: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 },
    cdCnt: { fontSize: 10.5, fontWeight: 800, color: '#0f6b5c', background: '#e2f0ec', borderRadius: 999, padding: '1px 6px', lineHeight: '14px', fontFamily: MONO },
    cdOut: { opacity: 0.4 },
    cdHas: { cursor: 'pointer' },
    cdToday: { boxShadow: 'inset 0 0 0 2px #0f6b5c' },
    cdSel: { background: '#e2f0ec', borderColor: '#0f6b5c' },
    cdHit: { background: '#fff3dc' },
    dn: { fontFamily: MONO, fontSize: 13, fontWeight: 700, lineHeight: '18px' },
    cn: { fontSize: 11.5, color: '#46524e' },
    nw: { fontSize: 10.5, color: '#3f51b5' },
    hdetail: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 12 },   // 2026-10-06 상단 S.desk 와 동일 컬럼 비율(카드 4장 같은 크기)
    gateBanner: { marginBottom: 12, fontSize: 13.5, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 8, padding: '10px 12px', fontWeight: 600 },
    toast: { position: 'fixed', left: '50%', bottom: 22, transform: 'translateX(-50%)', background: '#17201d', color: '#fff', padding: '8px 14px', borderRadius: 8, fontSize: 13, zIndex: 9999, maxWidth: 'calc(100% - 32px)' },
};

export default DeskReception;
